import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=4363452d&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4363452d')) {
      api.createRecord('4363452d', component.options)
    } else {
      api.reload('4363452d', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=4363452d&", function () {
      api.rerender('4363452d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2EpLz0ySriD1z/JS/videoIframe.vue"
export default component.exports